import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/google-ads/GoogleAdsBeyondClicks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/google-ads/GoogleAdsCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/google-ads/GoogleAdsHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/google-ads/GoogleAdsProcess.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/google-ads/GoogleAdsWhatIs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/google-ads/GoogleAdsWhatWeManage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
